<app-add-category [viewTitle]="title"></app-add-category>
